import { render } from "./S171485.vue?vue&type=template&id=e9fe201e"
const script = {}
script.render = render

export default script